import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withPreloading, PreloadAllModules, TitleStrategy } from '@angular/router';
import { provideIonicAngular, IonicRouteStrategy } from '@ionic/angular/standalone';
import { RouteReuseStrategy } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { OKTA_PROVIDERS } from './app/okta.config';
import { importProvidersFrom } from '@angular/core';
import { OktaAuthModule } from '@okta/okta-angular';
import { ToolbarTitleStrategy } from 'shared-lib';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';

// 👇 Ionicons: import addIcons + all icons
import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';


// Register *all* icons at app startup
addIcons(allIcons);

const isNativeAndroid = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

// Keep Android content below the system status bar
const configureStatusBar = async () => {
  if (!isNativeAndroid) {
    return;
  }

  try {
    await StatusBar.show();
    const info = await StatusBar.getInfo();
    console.log('[statusbar] overlays?', info.overlays, 'visible?', info.visible, 'style', info.style);
  } catch (err) {
    console.warn('[statusbar] failed to set overlay', err);
  }
};

void configureStatusBar();


bootstrapApplication(AppComponent, {
  providers: [
    provideIonicAngular({
      innerHTMLTemplatesEnabled: true, // allow <b>, <i>, etc. in ion-alert/ion-toast
    }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideAnimationsAsync(),
    provideHttpClient(withFetch()),
    provideRouter([...routes], withPreloading(PreloadAllModules)),

    // 👇 provides OktaAuthStateService & friends
    importProvidersFrom(OktaAuthModule),

    // 👇 provides OKTA_CONFIG + OKTA_AUTH (your instance with restoreOriginalUri)
    ...OKTA_PROVIDERS,

    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: TitleStrategy, useClass: ToolbarTitleStrategy },

  ],
});

(async () => {
  try {
    console.log('[http diag] fetch test starting');
    const r = await fetch(
      'https://osk.okta.com/oauth2/default/.well-known/openid-configuration',
      { headers: { Accept: 'application/json' } }
    );
    console.log('[http diag] fetch test status:', r.status);
  } catch (e) {
    console.error('[http diag] fetch test error:', e);
  }
})();

window.addEventListener('error', (e: any) => {
  console.error('[window.error]', e?.message, e?.error);
});
window.addEventListener('unhandledrejection', (e: any) => {
  console.error('[unhandledrejection]', e?.reason || e);
});
